import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/all",
      params: {
        organizationBusinessUnitId: (
          params as { organizationBusinessUnitId: string }
        ).organizationBusinessUnitId,
      },
      replace: true,
    });
  },
});
